export class SearchDirectoryEntitiesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "query",
            "baseName": "query",
            "type": "string",
            "format": ""
        },
        {
            "name": "entityType",
            "baseName": "entityType",
            "type": "DirectoryEntityType",
            "format": ""
        },
        {
            "name": "entityId",
            "baseName": "entityId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SearchDirectoryEntitiesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
